<template>
  <cos-modal
    v-model:visible="visible"
    :title="editForm.id ? t('btn.edit') : t('btn.add')"
    width="600px"
    @ok="handleSubmit"
    :confirmLoading="loading"
  >
    <a-form :model="editForm" ref="formRef" v-if="visible" autocomplete="off">
      <a-form-item
        name="arkCode"
        :label="t('operate.6rj8gj')"
        :rules="[{ required: true, message: t('common.pleaseSelect') }]"
      >
        <CusSelect appId="cos_ofbu" v-model:value="editForm.arkCode" @selectData="selectData" />
      </a-form-item>
      <a-form-item
        name="score"
        :label="t('operate.9bijib')"
        :rules="[{ required: true, message: t('common.pleaseInput') }]"
      >
        <a-input
          v-model:value="editForm.score"
          :maxlength="10"
          :precision="0"
          :placeholder="t('common.pleaseInput')"
          v-trim
        />
      </a-form-item>
    </a-form>
  </cos-modal>
</template>
<script lang="ts">
import { ref } from 'vue'
import { addBiScore, updateBiScore } from '@/api/overseasSales/businessRuleSetting'
import type { FormInstance } from 'ant-design-vue'
import { AddBiScoreParams } from '@/typings/api/overseasSales'
import CusSelect from '@/components/CustomerCodeSelect/index.vue'
import { DcMessage } from '@dc-platform/dc-components'
import { useI18n } from 'vue-i18n'

export default { name: 'editModal' }
</script>
<script setup lang="ts">
const { t } = useI18n()
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref<FormInstance>()
const editForm = ref<AddBiScoreParams>({})
const emit = defineEmits(['success'])
const toggle = (row?: AddBiScoreParams) => {
  visible.value = !visible.value
  if (row && row.id) {
    editForm.value = { ...row }
  } else {
    editForm.value = {}
  }
}
const selectData = (value: string) => {
  editForm.value.cosId = value
}
const handleSubmit = () => {
  formRef.value?.validate().then(async () => {
    loading.value = true
    const { arkCode, cosId, score, id } = editForm.value
    const p = {
      arkCode,
      cosId,
      score
    }
    try {
      if (editForm.value.id) {
        await updateBiScore({ ...p, id: editForm.value.id })
      } else {
        await addBiScore(p)
      }
      loading.value = false
      emit('success', editForm.value?.id ? 'edit' : 'add')
      DcMessage.success(editForm.value?.id ? t('operate.mmet2b') : t('operate.ywoekr'))
      toggle()
    } catch (error) {
      loading.value = false
    }
  })
}
defineExpose({
  toggle
})
</script>

<style lang="scss"></style>
